module.exports = __webpack_public_path__ + "assets/img/8f3537223ccc8a3359b970858028d516.jpeg";